// src/hooks/useTranslateDetails.js
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

export const useTranslateDetails = () => {
  const { t } = useTranslation();
  
  const translateDetailField = useCallback((fieldType, value) => {
    if (!value) return '';
    
    const translationKey = `apiTranslations.${fieldType}.${value}`;
    const translatedValue = t(translationKey);
    
    return translationKey === translatedValue ? value : translatedValue;
  }, [t]);
  
  return translateDetailField;
};